module.exports = __webpack_public_path__ + "static/media/step4.84a2d97f.gif";